<template>
  <div class="mod-caculator">
    <h3 v-if="moduleTitle">{{ moduleTitle }}</h3>
    <h3 v-else>{{ airlineName }}预付费行李费用计算器</h3>
    <a-form
      :form="form"
      layout="inline"
      hideRequiredMark
      @submit="handleSubmit"
    >
      <a-form-item label="出发城市">
        <air-flight-city-selector
          placeholder="出发城市"
          :data-source="cities"
          v-decorator="['departure', { rules: [{ required: true, message: '请选择出发城市!' }] }]"
        ></air-flight-city-selector>
      </a-form-item>
      <a-form-item label="到达城市">
        <air-flight-city-selector
          placeholder="到达城市"
          :data-source="cities"
          v-decorator="['arrival', { rules: [{ required: true, message: '请选择到达城市!' }] }]"
        ></air-flight-city-selector>
      </a-form-item>
      <a-form-item label="行李重量(KG)">
        <a-input-number
          :min="5"
          :step="5"
          @pressEnter="judgeNumber"
          v-decorator="['weight', { initialValue: 5, rules: [{ required: true, message: '请输入行李重量!' }] }]"
        ></a-input-number>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">
          查询
        </a-button>
      </a-form-item>
    </a-form>
    <div class="product-list">
      <a-spin v-if="loading"></a-spin>
      <template v-if="list && !loading">
        <template v-if="list.length">
          <table style="width: 100%;">
            <thead>
            <tr>
              <td>航段</td>
              <td>航距（KM）</td>
              <td v-if="(discount < 1) && list[0]?.totalWithDiscount">官网节日优惠价（元）</td>
              <td v-else-if="(discount >= 1) && list[0]?.total">官网优惠价（元）</td>
              <td v-if="list[0]?.offlineTotal">值机柜台标准价（元）</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in list" :key="item.id">
              <td>
                {{ item.depName }}
                -
                {{ item.arrName }}
              </td>
              <td>{{ item.distance }}</td>
              <td v-if="(discount < 1) && item.totalWithDiscount">{{ item.totalWithDiscount }}</td>
              <td v-else-if="(discount >= 1) && item.total">{{ item.total }}</td>
              <td v-if="item.offlineTotal">{{ item.offlineTotal }}</td>
            </tr>
            </tbody>
          </table>
          <p class="tip">（*以上查询结果仅供参考，具体请以官网完整告示或乘机当日现场收费为准）</p>
          <p>{{ airlineName }}官网更优惠，建议您提前购买</p>
        </template>
        <div class="empty" v-else>
          <p class="tip">未查询到您所输入的航段信息（如是中转航班，请分段查询）</p>
          <p>{{ airlineName }}官网更优惠，建议您提前购买</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import getAppInfo from '@/utils/from'
import { flightCities } from '@/assets/js/data'
import { getAirportName } from '@/assets/js/util'
import { queryBasePriceList } from '@/apis/ancillary'
import './caculator.less'

export default {
  props: {
    rules: Array,
    discount: Number,
    moduleTitle: String
  },
  data () {
    return {
      cities: [],
      form: this.$form.createForm(this),
      list: null,
      airlineName: getAppInfo()?.name,
      loading: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      const cities = await flightCities()

      if (cities) {
        this.cities = cities
      }
    },
    judgeNumber (e) {
      const value = e.target.value
      if (Number(value) % 5 !== 0) {
        this.$error({
          title: '温馨提示',
          content: '请填写正确的行李重量'
        })
      }
    },
    handleSubmit (e) {
      e.preventDefault()

      this.form.validateFields((err, values) => {
        if (!err) {
          this.fetch(values)
        }
      })
    },
    async fetch (values) {
      try {
        if (values.departure === values.arrival) {
          this.$error({
            title: '温馨提示',
            content: '请选择不同的出发、到达城市！'
          })
          return
        }

        this.loading = true
        const data = await queryBasePriceList({
          tkf_port: values.departure,
          ari_port: values.arrival
        })

        const { rules, discount, cities } = this
        const list = []
        data?.content.forEach(item => {
          for (const rule of rules) {
            if (rule.min <= item.distance && item.distance < rule.max) {
              list.push({
                ...item,
                depName: getAirportName(cities, item.tkf_port),
                arrName: getAirportName(cities, item.ari_port),
                totalWithDiscount: rule.amount * values.weight * discount,
                total: rule.amount * values.weight,
                offlineTotal: rule.offlineAmount * values.weight
              })
              break
            }
          }
        })
        this.list = list
        this.loading = false
      } catch (err) {
        this.list = []
        this.loading = false
        this.$error({
          title: '温馨提示',
          content: err.message || '网路异常，请稍后再试！'
        })
      }
    }
  }
}
</script>
